<template>
  <div class="suporte">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <p class="subtitulo">SUPORTE</p>
          <h1 class="titulo rosa-padrao-cor">ESTAMOS AQUI PARA TE AJUDAR</h1>
          <p class="descricao mb-5">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam sed mattis tellus. Aliquam id dignissim elit. Ut eu est felis. Praesent accumsan, est et dignissim ornare, massa tellus condimentum neque, vitae rhoncus sem arcu at turpis. 

            Phasellus dapibus maximus ante sed sollicitudin. Duis ac nisl nec dui convallis ullamcorper. Suspendisse potenti. Integer nisi elit, mollis ac lacus at, ultricies porta dolor. Aenean ut risus sit amet leo dapibus placerat. Nullam sit amet ornare tellus, a pretium lectus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Donec sodales neque sit amet ullamcorper posuere. Mauris ultrices purus vitae aliquet porttitor. Morbi sollicitudin purus nec pellentesque iaculis. Vivamus vel neque a justo convallis rhoncus vitae et nisi.
          </p>
        </div>
      </div>
      <div class="container-grid">
        <router-link to="/" class="item">
          <p>GUIAS GERAIS</p>
        </router-link>
        <router-link to="/" class="item">
          <p>GUIAS GERAIS</p>
        </router-link>
        <router-link to="/" class="item">
          <p>GUIAS GERAIS</p>
        </router-link>
        <router-link to="/" class="item">
          <p>GUIAS GERAIS</p>
        </router-link>
        <router-link to="/" class="item">
          <p>GUIAS GERAIS</p>
        </router-link>
        <router-link to="/" class="item">
          <p>GUIAS GERAIS</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.subtitulo {
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 2px;
}
.titulo {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 50px;
}
.container-grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr 1fr 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  .item {
    aspect-ratio: 1;
    display: flex;
    align-items: flex-end;
    background-color: #EFF1F3;
    padding: 15px;
    margin-bottom: 15px;
    color: #000;
    text-decoration: none;
    transition: 0.3s;
    &:hover {
      box-shadow: 5px 5px 20px rgba(0,0,0,0.2);
    }
    p {
      font-weight: 700;
      font-size: 20px;
      margin-bottom: 0;
    }
  }
}

@media (min-width: 768px) {
  .container-grid {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    .item {
      margin: 0 7.5px 15px 5px;
    }
  }
}

@media (min-width: 992px) {
  .container-grid {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    .item {
      margin: 0 7.5px 15px 5px;
    }
  }
}
</style>

<script>
export default {
  name: 'Suporte',
  data() {
    return {}
  },
  components: {
  }
}
</script>